import React from "react";
import { AlertTriangle } from "lucide-react";

export default function Disclaimer({ compact = false }) {
    return (
        <div
            data-testid="disclaimer-banner"
            className={`ccs-disclaimer rounded-lg flex items-start gap-3 ${compact ? "p-3" : "p-4"}`}
        >
            <AlertTriangle className="h-5 w-5 text-[#1E3A8A] flex-shrink-0 mt-0.5" />
            <p className="text-sm leading-relaxed">
                <span className="font-semibold text-[#0F172A]">Estimate only.</span>{" "}
                This calculator provides an estimate only. Actual Child Care Subsidy (CCS) amounts are determined by the Australian Government via Services Australia.
            </p>
        </div>
    );
}
